import { useMsal } from "@azure/msal-react";
import {
    Grid,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useStyles } from "./geraeteManagementStyles";
import {
    selectNewMode, setNewMode, setEditMode, discardEdits, saveEdit, selectEditMode,
    selectSelectedAktiverMesspunkt, setSelectedAktiverMesspunkt, emptyAktiverMesspunkt,
    deleteZuordnung, setSelectedUW, emptyGeraet, emptyMessstelle, emptyRouter,
    setGeraetDaten, setRouterDaten, setMessstelleDaten, selectMessstelleDaten, selectGeraetDaten,
    selectRouterDaten, selectMesspunkt, getMessstellen, getMessgeraete, getRouter, createActiveMesspunkt,
    resetSelection, selectMesspunktLoading
} from "./geraeteManagementSlice";
import { globalStyles } from "../../assets/globalStyles";
import { isAuthorized, rollen } from "../../utils/auth/authConfig";


export const ButtonInteraktion: React.FC = () => {
    const dispatch = useAppDispatch();

    const { instance } = useMsal();
    const rollenObj = rollen;


    useEffect(() => {
        dispatch(getMessstellen());
        dispatch(getMessgeraete());
        dispatch(getRouter());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const selectedAktiverMesspunkt = useAppSelector(selectSelectedAktiverMesspunkt);
    const messpunktLoading = useAppSelector(selectMesspunktLoading);

    const newMode = useAppSelector(selectNewMode);
    const editMode = useAppSelector(selectEditMode);

    const messstelleDaten = useAppSelector(selectMessstelleDaten);
    const messgeraetDaten = useAppSelector(selectGeraetDaten);
    const routergeraetDaten = useAppSelector(selectRouterDaten);

    const confirmDeleteOfMesspunkt = () => {
        dispatch(deleteZuordnung(selectedAktiverMesspunkt));
        setOpenDeleteDialog(false);
        dispatch(setSelectedAktiverMesspunkt(emptyAktiverMesspunkt));
        dispatch(setSelectedUW(""));
    }

    return (
        <React.Fragment>
            {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                <React.Fragment>
                    {editMode ?
                        <Grid item md={6} style={{ paddingRight: "20px", textAlign: "right" }}>
                            <Button
                                data-cy="aktiver-messpunkt-abbrechen-button"
                                variant="contained"
                                color="secondary"
                                onClick={() => (
                                    dispatch(discardEdits()),
                                    dispatch(setEditMode(false))
                                )}
                                style={{ minHeight: "36px", width: "225px", marginRight: "10px" }}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                data-cy="aktiver-messpunkt-speichern-button"
                                variant="contained"
                                color="secondary"
                                style={{ minHeight: "36px", width: "225px" }}
                                onClick={() => (
                                    dispatch(setEditMode(false)),
                                    dispatch(setMessstelleDaten(messstelleDaten)),
                                    dispatch(setGeraetDaten(messgeraetDaten)),
                                    dispatch(setRouterDaten(routergeraetDaten)),
                                    dispatch(saveEdit(selectedAktiverMesspunkt, messgeraetDaten, routergeraetDaten))


                                )}>
                                {messpunktLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
                            </Button>
                        </Grid>

                        : [newMode ?

                            <Grid item md={6} style={{ paddingRight: "20px", textAlign: "right" }}>
                                <Button
                                    data-cy="neuer-messpunkt-abbrechen-button"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => (
                                        dispatch(setNewMode(false)),
                                        dispatch(resetSelection()),
                                        dispatch(setSelectedUW("")),
                                        dispatch(setMessstelleDaten(emptyMessstelle)),
                                        dispatch(setGeraetDaten(emptyGeraet)),
                                        dispatch(setRouterDaten(emptyRouter))
                                    )
                                    }
                                    style={{ minHeight: "36px", width: "225px", marginRight: "10px" }}
                                >
                                    Abbrechen
                                </Button>
                                <Button
                                    data-cy="neuer-messpunkt-speichern-button"
                                    variant="contained"
                                    color="secondary"
                                    style={{ minHeight: "36px", width: "225px" }}
                                    disabled={messstelleDaten == emptyMessstelle || messgeraetDaten == emptyGeraet}
                                    onClick={() => {
                                        dispatch(setNewMode(false));
                                        dispatch(createActiveMesspunkt(messstelleDaten, messgeraetDaten, routergeraetDaten));
                                        dispatch(selectMesspunkt(selectedAktiverMesspunkt ? selectedAktiverMesspunkt : emptyAktiverMesspunkt));

                                    }}
                                >
                                    {messpunktLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
                                </Button>
                            </Grid>
                            :
                            <Grid item md={6} style={{ paddingRight: "20px", textAlign: "right" }}>
                                <Button
                                    data-cy="aktiver-messpunkt-bearbeiten-button"
                                    variant="contained"
                                    color="secondary"
                                    disabled={selectedAktiverMesspunkt == emptyAktiverMesspunkt}
                                    onClick={() => (
                                        dispatch(setEditMode(true))
                                    )}
                                    style={{ minHeight: "36px", width: "225px", marginRight: "10px" }}
                                >
                                    Bearbeiten
                                </Button>
                                {selectedAktiverMesspunkt != emptyAktiverMesspunkt ?
                                    <Button
                                        data-cy="aktiver-messpunkt-loeschen-button"
                                        variant="contained"
                                        onClick={() => setOpenDeleteDialog(true)}
                                        disabled={selectedAktiverMesspunkt == emptyAktiverMesspunkt}
                                        style={{ minHeight: "36px", width: "225px" }}
                                        color="secondary"
                                        className={`${classes.backgroundColorErrorDark}`}
                                    >
                                        Löschen
                                    </Button> : ""}
                                <Dialog
                                    data-cy="aktiver-messpunkt-dialog-loeschen"
                                    open={openDeleteDialog}
                                    onClose={() => setOpenDeleteDialog(false)}
                                >
                                    <DialogTitle>Aktiven Messpunkt löschen</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            {'Sind Sie sicher, dass Sie den aktiven Messpunkt "' +
                                                selectedAktiverMesspunkt.name +
                                                '" wirklich löschen wollen?'}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            data-cy="aktiver-messpunkt-dialog-abbrechen-button"
                                            color="secondary"
                                            variant="contained"
                                            onClick={() => setOpenDeleteDialog(false)}
                                            className={classes.cancleDeleteButton}
                                        >
                                            Abbrechen
                                        </Button>
                                        <Button
                                            data-cy="aktiver-messpunkt-dialog-loeschen-button"
                                            variant="contained"
                                            onClick={confirmDeleteOfMesspunkt}
                                            className={classes.confirmDeleteButton}
                                            style={{ minWidth: "120px", minHeight: "36px" }}
                                        >
                                            {messpunktLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Grid>

                        ]}
                </React.Fragment>
                : ""}
        </React.Fragment >
    );
}